import { render, staticRenderFns } from "./SettingsWebhooksEndpointModalForm.vue?vue&type=template&id=70a1f874"
import script from "./SettingsWebhooksEndpointModalForm.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooksEndpointModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports